export default {"src":"/_next/static/image/public/images/ic_female_blue.1f0ffa2f137928e597f29e87dcd9ea9b.svg","height":24,"width":25};